import { render } from "./ArticleItem.vue?vue&type=template&id=2caded52"
import script from "./ArticleItem.vue?vue&type=script&lang=js"
export * from "./ArticleItem.vue?vue&type=script&lang=js"

import "./ArticleItem.vue?vue&type=style&index=0&id=2caded52&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__